<div   class="cover py-5"   [ngStyle]="{'background-image': 'url(' + coverPrefix + tvshowdetails.poster_path+ ')'}">   
    
    <div class="captions container ">
    
        <div class="row">
            <div class="col-md-8 d-flex align-content-around flex-wrap">
                <div class="  caption m-5 " >
        
        
                
                    <h1 class="title">{{tvshowdetails.original_name}}</h1>
                    <p class="tagline"> {{tvshowdetails.tagline}} </p>

                    <p class="text-justify "> {{tvshowdetails.overview}}</p>
                
                    <p> <span class="detailsHeader">number_of_episodes:</span> {{tvshowdetails.number_of_episodes}}</p>
                    <p> <span class="detailsHeader">number_of_seasons:</span> {{tvshowdetails.number_of_seasons}}</p>


                    <p> <span class="detailsHeader">vote_count:</span>{{tvshowdetails.vote_count}} </p>
                
                
                
                
                </div>
                
            </div>
            
            <div class="col-md-4 my-5">
            <div class="px-5">
                <div class="rate">
                    <button class="btn btn-warning"> {{tvshowdetails.vote_average}}</button>
        
                </div>
        
                <img [src]="imgPrefix + tvshowdetails.poster_path"  class="imgPoster m-auto img-fluid" alt="">
            </div>
            </div>
        
        </div>
            
    
    
    </div>

</div>


<section class="container my-5">


<div class="cast">
    <h2 class="header text-center my-5"> <span>***************</span>  Cast <span>***************</span></h2>

    <div class="row">
        
    <div *ngFor="let x of cast" class="col-md-2  col-sm-4 my-3 py-5">
    
        <img [src]=" imgPrefix+x.profile_path"  class="img-fluid" alt="">
        <h5>{{x.name}}</h5>
    </div>
    </div>

</div>

<div class="row">
  
    <div class="col-md-12 ">
        
    <h2 class="header text-center my-5"> <span>***************</span> Official Trailer <span>***************</span></h2>

    <iframe class="w-100 " height="500" [src]="url | safe"  allowfullscreen></iframe>
    </div>

</div>

</section>
